/**
 * Canvas events supported by surface3D
 * The controls work for different browsers and touch devices by including mouse, touch and pointer events
 */
export enum CanvasEvent {
    Down,
    Up,
    Move,
    Double
}

/**
 * Class for defining methods reacting to mouse/pointer/touch events on 3d canvas
 *
 * events: map of CanvasEvents -> function to be executed on this event
 *
 * init: function to be executed on activating control
 * finish: function to be executed on changing control
 *
 * rotate: enable orbit controls rotation?
 * zoom: enable orbit controls zoom?
 * pan: enable pan by offsetting view?
 * controlMode: standard (true) vs. alternative (false) orbit controls
 */
export class CanvasControl {

    public events: Map<CanvasEvent, (event?: MouseEvent) => void>;

    public init?: () => void;
    public finish?: () => void;

    rotate?: boolean;
    public zoom?: boolean;
    public pan?: boolean;

    // TODO: change data type
    public controlMode?: boolean;
}
